/**
 * Identidad del usuario "dueño" de las capturas offline de ESTE device.
 *
 * El boot cablea un resolver lazy que lee el usuario autenticado. Sirve para dos cosas:
 *  1. Sellar cada op del outbox con su `user_id` al insertarla (BaseRepository._buildOutboxInsert).
 *  2. Que el drain filtre por usuario (sync/outbox.js) -> un device COMPARTIDO no debe pushear las
 *     ocurrencias capturadas por el usuario A bajo la sesión del usuario B.
 *
 * Si el resolver NO está cableado (tests / antes del login), getOfflineUserId() devuelve null y el
 * drain DEGRADA a "sin filtro" (comportamiento previo) — nunca bloquea la sincronización por no
 * conocer al usuario. Las filas legacy con user_id NULL también drenan bajo cualquier usuario.
 *
 * Módulo leaf (cero imports): lo consumen tanto repositories/ como sync/ sin acoplar capas.
 */
let _resolver = null

/** Cableado por el boot: `setOfflineUserResolver(() => useUsersStore().current?.id)`. */
export function setOfflineUserResolver (fn) {
  _resolver = typeof fn === 'function' ? fn : null
}

/** id numérico del usuario actual, o null si no se conoce (resolver sin cablear / sin sesión). */
export function getOfflineUserId () {
  if (!_resolver) return null
  try {
    const id = _resolver()
    return id != null ? Number(id) : null
  } catch {
    return null
  }
}
